import {createContext, useContext} from 'react';
import {IDragDropManager} from './types';

export const InnerDragNDropContext = createContext<{manager: IDragDropManager}>(undefined);

export function useDragDropManager(): IDragDropManager | undefined {
	const context = useContext(InnerDragNDropContext);
	return context?.manager;
}
